/* eslint-disable */
import React from 'react'
import {message} from 'antd'
import http from '../../../Component/Interceptor/Interseptor'
import {Link} from 'react-router-dom'
import TMS from '../../BaseComponent/TMS'

class CreateTaskUnit extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      error: ''
    }
  }

  addTaskUnit() {
    let title = document.getElementById('title').value
    let description = document.getElementById('description').value

    let formError = false

    if (title === '') {
      formError = true
      message.error('عنوان وارد شود')
    }

    if (!formError) {
      let data = {
        title,
        description,
        enabled: true
      }

      http
        .post(`${TMS.TMS_MANAGE_BASE_TASKUNIT_CREATE}`, data)
        .then((response) => {
          if (response.data.error == null) {
            message.success('واحد فعالیت جدید اضافه شد')
            setInterval(() => {
              window.location.assign('/base/report/tms/taskUnit')
            }, 2000)
          } else {
          }
        })
        .catch((error) => {
          // alert(JSON.stringify(error))
        })
    }
  }

  submit(e) {
    e.preventDefault()
  }
  render() {
    return (
      <div className={'rtl'}>
        {/*<AdminMenu/>*/}
        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>اطلاعات پایه</li>
            <li>مدیریت وظایف</li>
            <li>
              <Link to={'/base/report/tms/taskUnit'}>واحد وظایف</Link>
            </li>
            <li>افزودن واحد فعالیت</li>
          </ul>
          <form className="verticalForm" onSubmit={this.submit.bind(this)}>
            <div className="headerVertical">
              <p>افزودن واحد فعالیت</p>
            </div>
            <div className="formComponent">
              <label>
                عنوان <span className="requireFiled">*</span>
              </label>
              <input type="text" id="title" className="form-control" />

              <label>توضیحات</label>
              <textarea className="form-control" id="description" />

              <button className="btn btn-info btn-block" onClick={this.addTaskUnit.bind(this)}>
                ثبت واحد
              </button>
            </div>
          </form>
        </div>
      </div>
    )
  }
}

export default CreateTaskUnit
